/* eslint-disable no-console */
import React from 'react';
import './styles.scss';

function Presentations() {
  return (
    <div>
      <div className="news" id="news">
        <ul>
          <li>
            <p>
              <b>Aug, 2026 </b>
              – Contribution à <a href="https://github.com/6chaoran/jupyter-summarytools" target="_blank" rel="noreferrer">l'implémentation Python de summarytools</a> pour générer des tableaux standardisés et complets de DataFrames dans des notebooks Jupyter.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jan, 2026 </b>
              – Ravi d'annoncer que mes plus récents travaux postdoctoraux sont désormais disponible <a href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=6145286" target="_blank" rel="noreferrer">en ligne</a>.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Sep, 2025 </b>
              – Co-organisateur des <a href="https://www.imperial.ac.uk/mathematical-finance/events/finance-and-stochastics/" target="_blank" rel="noreferrer">séminaires Finance & Stochastics</a> du groupe de recherche en mathématiques financières à Imperial College London.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Mars, 2025 </b>
              – Notre article <a href="https://doi.org/10.1111/mafi.12388" target="_blank" rel="noreferrer">"RL with Dynamic Convex Risk Measures"</a> a été reconnu comme l'un des plus cités dans le journal Mathematical Finance parmi les travaux publiés en 2023.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Juin, 2024 </b>
              – Débuté un nouveau poste d'associé de recherche à Imperial College London.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Fév, 2024 </b>
              – Invité à présenter mes travaux de recherche au
              <a href="https://statqam.uqam.ca/" target="_blank" rel="noreferrer"> séminaire de STATQAM</a>
              , à Montréal le 15 février 2024.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Juin, 2023 </b>
              – Récipiendaire du Prix d'excellence pour la recherche doctorale du DoSS de l'Université de Toronto.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Juin, 2023 </b>
              – Récipiendaire du
              <a href="https://www.siam.org/prizes-recognition/activity-group-prizes/detail/siag-fme-conference-paper-prize" target="_blank" rel="noreferrer"> SIAG/FME Conference Paper Prize</a> au
              <a href="https://www.siam.org/conferences/cm/conference/fm23" target="_blank" rel="noreferrer"> SIAM Conference on Financial Mathematics and Engineering</a>
              , à Philadelphie du 6-9 juin 2023.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Oct, 2022 </b>
              – Invité à présenter mes travaux de recherche au
              <a href="https://meetings.informs.org/wordpress/indianapolis2022" target="_blank" rel="noreferrer"> Congrès annuel INFORMS</a>
              , à Indianapolis du 16-19 octobre 2022.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Jan, 2022 </b>
              – Étudiant étranger à l'
              <a href="https://www.oxford-man.ox.ac.uk/previous-visitors/" target="_blank" rel="noreferrer"> Oxford-Man Institute</a>
              , Université d'Oxford, pendant une période de 6 mois; invité par
              <a href="https://sites.google.com/site/alvarocartea/home" target="_blank" rel="noreferrer"> Prof. Álvaro Cartea</a>.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Sep, 2021 </b>
              – Membre du comité de programme pour l'
              <a href="https://ai-finance.org/" target="_blank" rel="noreferrer">ACM International Conference on AI in Finance</a>
              , qui s'est tenu en ligne du 3-5 Novembre 2021. Je faisais partie du processus
              de d'évaluation par les pairs à double insu.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Juin, 2021 </b>
              – Membre du comité organisateur du
              <a href="https://ssc.ca/fr/congres/annuel/congres-annuel-2021/neuvieme-congres-canadien-etudiants-en-statistique" target="_blank" rel="noreferrer"> Congrès canadien des étudiants en statistique 2021</a>
              , qui s'est tenu en ligne (plutôt qu'à l'Université Memorial à Saint-Jean de Terre-Neuve
              en raison de la COVID-19) le 5 juin 2021.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Mai, 2020 </b>
              – Membre du comité organisateur du
              <a href="https://ssc.ca/fr/congres/annuel/congres-annuel-2020/congres-canadien-etudiants-en-statistique" target="_blank" rel="noreferrer"> Congrès canadien des étudiants en statistique 2020</a>
              , qui s'est tenu en ligne (plutôt qu'à l'Université Carleton à Ottawa en raison de la
              COVID-19) le 30 mai 2020. Je faisais partie de l'équipe de traduction, j'étais
              président d'une session et modérateur.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              <b>Mars, 2019 </b>
              – Co-organisé le Sommet étudiant de la statistique à Montréal, qui s'est tenu à l'UQAM le 15 mars
              2019. Cette nouvelle initiative visait à réunir les étudiants
              francophones en statistique pour une journée de présentations.
              <a href="http://probability.ca/jeff/" target="_blank" rel="noreferrer"> Jeffrey S. Rosenthal </a>
              et
              <a href="https://sahirbhatnagar.com/" target="_blank" rel="noreferrer"> Sahir Rai Bhatnagar </a>
              étaient nos conférenciers invités.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Presentations;
